// extracted by mini-css-extract-plugin
export default {"kpiCard":"card_kpiCard__Wy12I","kpiCardList":"card_kpiCardList__HibQ6","kpiCardHeader":"card_kpiCardHeader__z9CkQ"};